import { Controller } from "@hotwired/stimulus"

// Keeps each filter tab's `selected/total` badge in sync with the checkboxes in
// its panel. Listens for `check-all:count` events bubbling up from the per-panel
// `check-all` controllers and updates the badge whose `tabCountId` matches the
// panel that dispatched the event. The panel identity comes from the panel's
// `data-tab-count-panel` (set by the tab-panel component) or, failing that, its
// `id` (which the tabs controller already keys panels off of).
export default class extends Controller {
  static targets = ["badge"]

  update(event) {
    const panel = event.target.closest('[data-tabs-target="panel"]')
    if (!panel) return

    const panelId = panel.dataset.tabCountPanel || panel.id
    const badge = this.badgeTargets.find(
      (badge) => badge.dataset.tabCountId === panelId
    )
    if (!badge) return

    const { selected, total } = event.detail
    badge.textContent = `${selected}/${total}`
  }
}
